import React from 'react';
import { Link } from 'react-router-dom';
import ReactQuill from 'react-quill';
import moment from 'moment';
import _ from 'lodash';

import icon from '../../assets/icon_edit.svg';

interface OnboardingData {
  emotionalState: string[];
  personality: string[];
  trauma: string[];
}

interface UserMindStatusProps {
  onboardingData: OnboardingData | null;
  dailyJournal: { content: string; emotion: number } | null;
  getEmoji: (emotion: number) => string;
  renderTags: (tags: string[] | undefined) => JSX.Element;
}

const UserMindStatus: React.FC<UserMindStatusProps> = ({
  onboardingData,
  dailyJournal,
  getEmoji,
  renderTags,
}) => {
  return (
    <section className="setting-section">
      <div className="section-header">
        <h2>나의 마음 상태</h2>
        <Link
          to={onboardingData ? '/profile/onboarding-edit' : '/onboarding'}
          className="edit-link"
        >
          {onboardingData ? (
            <>
              <img src={icon} alt="수정" />
              <p>수정</p>
            </>
          ) : (
            <>
              <img src={icon} alt="기록" />
              <p>기록</p>
            </>
          )}
        </Link>
      </div>
      <div className="section-mind">
        <div>
          <h4>나의 요즘 기분</h4>
          {renderTags(_.get(onboardingData, 'emotionalState'))}
        </div>
        <div>
          <h4>관심 주제/걱정거리</h4>
          {renderTags(_.get(onboardingData, 'trauma'))}
        </div>
        <div>
          <h4>나의 성향</h4>
          {renderTags(_.get(onboardingData, 'personality'))}
        </div>
        <div
          className="daily-journal-wrap"
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <h4>
            오늘의 마음 상태 ({moment().format('YYYY.MM.DD')}){' '}
            <img
              src={getEmoji(_.get(dailyJournal, 'emotion'))}
              alt="emoji"
              style={{ width: 25, height: 25 }}
            />
          </h4>
        </div>
        {dailyJournal && _.get(dailyJournal, 'content') ? (
          <div className="daily-journal-quill" translate="no">
            <ReactQuill value={_.get(dailyJournal, 'content')} readOnly={true} theme="snow" />
          </div>
        ) : (
          <p>오늘의 한마디를 작성해주세요.</p>
        )}
      </div>
    </section>
  );
};

export default UserMindStatus;
